export default __webpack_public_path__ + "static/media/Jenny_Timur-521_websize.0bef3ed1.jpg";